if(!customElements.get("fixed-price")) {
  class FixedPrice extends HTMLElement {
    constructor() {
      super();
    }

    variantIdChangedUnsubscriber = undefined;

    connectedCallback() {
      // 元素
      this.element = {
        productPriceList: document.querySelector('.product__info-wrapper .product-price-list'),
        priceWrapper: this.querySelector('.price-wrapper'),
        mobilePrice: this.querySelector('.mobile-price')
      }
      this.initFixedPrice();
    }

    initFixedPrice() {
      if(this.element.productPriceList) {
        var discount = this.element.productPriceList?.getAttribute('data-discount');
        // 订阅事件：变体切换
        if(discount) {
          this.variantIdChangedUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            let variant = event.data.variant;
            if(discount.indexOf('%') > -1) {
              var discount_price = variant.price * (1 - (discount.split('%')[0] / 100));
            } else {
              var discount_price = (variant.price - discount * 100);
            }
            this.element.mobilePrice.innerHTML = `<span class="money">${window.active_currency_symbol}${(Math.round(discount_price) / 100).toFixed(2)}</span>`;
            this.element.priceWrapper.setAttribute('data-curr-price', discount_price);
          });
  
          document.addEventListener('DOMContentLoaded', () => {
            let default_price = this.element.priceWrapper?.getAttribute('data-curr-price');
            if(discount.indexOf('%') > -1) {
              var discount_price = default_price * (1 - (discount.split('%')[0] / 100));
            } else {
              var discount_price = (default_price - discount * 100);
            }
            this.element.mobilePrice.innerHTML = `<span class="money">${window.active_currency_symbol}${(Math.round(discount_price) / 100).toFixed(2)}</span>`;
            this.element.priceWrapper.setAttribute('data-curr-price', discount_price);
          });
        }
      }else {
        this.variantIdChangedUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          let variant = event.data.variant;
          this.element.mobilePrice.innerHTML = `<span class="money">${window.active_currency_symbol}${(Math.round(variant.price) / 100).toFixed(2)}</span>`;
          this.element.priceWrapper.setAttribute('data-curr-price', variant.price);
        });
      }
    }

    disconnectedCallback() {
      if (this.variantIdChangedUnsubscriber) {
        this.variantIdChangedUnsubscriber();
      }
    }
  }
  customElements.define("fixed-price", FixedPrice);
}